var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHotspotDrop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 74,
    height: 90.971,
    viewBox: "0 0 74 90.971",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_208",
    "data-name": "Group 208",
    transform: "translate(-1833 7642.971)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_207",
    "data-name": "Group 207",
    transform: "translate(73.541 1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-plus-circle",
    "data-name": "Icon feather-plus-circle",
    transform: "translate(1811.454 -7643.97)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_311",
    "data-name": "Path 311",
    d: "M25,14a11.119,11.119,0,0,1-4.3,8.725A10.759,10.759,0,0,1,14,25,11,11,0,1,1,25,14Z",
    transform: "translate(-3 -3)",
    fill: "#7315ce"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_312",
    "data-name": "Path 312",
    d: "M18,12v8.8",
    transform: "translate(-6.997 -5.399)",
    fill: "#7315ce",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_313",
    "data-name": "Path 313",
    d: "M12,18h8.8",
    transform: "translate(-5.398 -6.998)",
    fill: "#7315ce",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_67",
    "data-name": "Ellipse 67",
    transform: "translate(1833 -7626)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37,0A37,37,0,1,1,0,37,37,37,0,0,1,37,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 37 7 C 20.45795059204102 7 7 20.45795059204102 7 37 C 7 53.54204940795898 20.45795059204102 67 37 67 C 53.54204940795898 67 67 53.54204940795898 67 37 C 67 20.45795059204102 53.54204940795898 7 37 7 M 37 0 C 57.43453216552734 0 74 16.56546783447266 74 37 C 74 57.43453216552734 57.43453216552734 74 37 74 C 16.56546783447266 74 0 57.43453216552734 0 37 C 0 16.56546783447266 16.56546783447266 0 37 0 Z",
    stroke: "none",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_68",
    "data-name": "Ellipse 68",
    cx: 21.5,
    cy: 21.5,
    r: 21.5,
    transform: "translate(1849 -7610)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHotspotDrop);
export default __webpack_public_path__ + "static/media/hotspot_drop.45549745ca463bc1ab57ab634edd0f5b.svg";
export { ForwardRef as ReactComponent };